<script>
import { PhxAutocomplete } from '@phx-styleguides/jlc';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    PhxAutocomplete,
  },

  props: {
    isSuggestionActivated: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['query', 'change', 'geolocation'],

  data() {
    return {
      formData: {
        query: '',
      },
      defaultSuggestions: [
        {
          key: 'geolocation',
          value: this.$t('StoreSearch.useMyPosition'),
          icon: 'pin-16',
          divided: true,
        },
      ],
    };
  },

  computed: {
    ...mapState('storeSearch', ['placeSuggestions', 'isSuggestionLoading']),

    ...mapGetters('storeSearch', ['searchPerformed']),

    options() {
      if (this.formData.query === '') {
        return this.defaultSuggestions;
      }

      return this.placeSuggestions.map((place) => ({
        key: place.key,
        value: place.suggestion,
        highlightedText: place.formattedSuggestion,
      }));
    },

    noResultsText() {
      return this.$t(
        this.formData.query === '' ? 'StoreSearch.suggestions.proviceSearchTerm' : 'StoreSearch.suggestions.noResults',
      );
    },
  },

  methods: {
    onQuery(query) {
      this.formData.query = query;

      this.$emit('query', { query });
    },

    onChange(value) {
      if (value?.key === 'geolocation') {
        return this.$emit('geolocation');
      }

      if (value) {
        this.$emit('change', value);
      }
    },
  },
};
</script>

<template>
  <div data-cy="store-search-form">
    <phx-autocomplete
      id="store-locator-autocomplete"
      name="store-locator-autocomplete"
      :hide-label="true"
      :label="$t('StoreSearch.placeholder')"
      :placeholder="$t('StoreSearch.placeholder')"
      :clear-button-label="$t('StoreSearch.suggestions.clear')"
      :open-button-label="$t('StoreSearch.suggestions.open')"
      :no-result-text="noResultsText"
      :loading-text="$t('StoreSearch.suggestions.loading')"
      :loading="isSuggestionLoading"
      :options="options"
      open-button-icon="search-16"
      clear-button-icon="cross-16"
      @autocomplete:query="onQuery"
      @autocomplete:change="onChange"
    >
    </phx-autocomplete>
  </div>
</template>
